import type {
  AdminVersionActionRequest,
  ArchiveAdminAppVersionReply,
  CreateAdminAppCatalogAppReply,
  CreateAdminAppCatalogAppRequest,
  CreateAdminAppVersionReply,
  CreateAdminAppVersionRequest,
  ListAdminAppCatalogReply,
  ListAdminAppVersionsReply,
  PublishAdminAppVersionReply,
  SetLatestAdminAppVersionReply,
  UpdateAdminAppCatalogAppReply,
  UpdateAdminAppCatalogAppRequest,
} from '@/types';
import desktopApi from './desktopApi';

const APP_CENTER_ADMIN_BASE = 'v1/admin/app-center';

function appPath(appId: string) {
  return `${APP_CENTER_ADMIN_BASE}/apps/${encodeURIComponent(appId)}`;
}

function versionPath(appId: string, versionId: string) {
  return `${appPath(appId)}/versions/${encodeURIComponent(versionId)}`;
}

export const applicationApi = {
  listApps: async (): Promise<ListAdminAppCatalogReply> => {
    return desktopApi.get(`${APP_CENTER_ADMIN_BASE}/apps`);
  },

  createApp: async (
    data: CreateAdminAppCatalogAppRequest,
  ): Promise<CreateAdminAppCatalogAppReply> => {
    return desktopApi.post(`${APP_CENTER_ADMIN_BASE}/apps`, data);
  },

  updateApp: async (
    data: UpdateAdminAppCatalogAppRequest,
  ): Promise<UpdateAdminAppCatalogAppReply> => {
    return desktopApi.patch(appPath(data.appId), data);
  },

  listVersions: async (appId: string): Promise<ListAdminAppVersionsReply> => {
    return desktopApi.get(`${appPath(appId)}/versions`);
  },

  createVersion: async (
    data: CreateAdminAppVersionRequest,
  ): Promise<CreateAdminAppVersionReply> => {
    return desktopApi.post(`${appPath(data.appId)}/versions`, data);
  },

  publishVersion: async ({
    appId,
    versionId,
    reason,
  }: AdminVersionActionRequest): Promise<PublishAdminAppVersionReply> => {
    return desktopApi.post(`${versionPath(appId, versionId)}/publish`, {
      appId,
      versionId,
      reason,
    });
  },

  setLatestVersion: async ({
    appId,
    versionId,
    reason,
  }: AdminVersionActionRequest): Promise<SetLatestAdminAppVersionReply> => {
    return desktopApi.post(`${versionPath(appId, versionId)}/set-latest`, {
      appId,
      versionId,
      reason,
    });
  },

  archiveVersion: async ({
    appId,
    versionId,
    reason,
  }: AdminVersionActionRequest): Promise<ArchiveAdminAppVersionReply> => {
    return desktopApi.post(`${versionPath(appId, versionId)}/archive`, {
      appId,
      versionId,
      reason,
    });
  },
};
